import {CONTINUE_PAGE_AFTER_AUTHORIZE} from './serve/consts';
import {get, remove, set} from './serve/sessionStorage';

export function consumeContinuePageAfterAuthorize() {
  const value = get<string>(CONTINUE_PAGE_AFTER_AUTHORIZE);

  remove(CONTINUE_PAGE_AFTER_AUTHORIZE);

  if (value === '') {
    return null;
  }

  return value;
}

export function setContinuePageAfterAuthorize(value: string): void {
  set(CONTINUE_PAGE_AFTER_AUTHORIZE, value);
}
